import { render, staticRenderFns } from "./hotspots.vue?vue&type=template&id=1274376d&scoped=true"
import script from "./hotspots.vue?vue&type=script&lang=js"
export * from "./hotspots.vue?vue&type=script&lang=js"
import style0 from "./hotspots.vue?vue&type=style&index=0&id=1274376d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274376d",
  null
  
)

export default component.exports